module.exports = __webpack_public_path__ + "static/media/karansingh.667cfa27.jpg";